import { Controller } from "@hotwired/stimulus"

/**
 * Form Reset Controller - Generic controller for handling form resets and submissions
 */
export default class extends Controller {
  connect() {
    // Initialize any necessary state when the controller connects
  }

  clearAndSubmit(event) {
    event.preventDefault()
    event.stopPropagation()
    
    // Reset the form
    const form = this.getFormElement()
    if (form) {
      form.reset()
    }
    
    // Submit the form using Turbo to prevent page redirection
    this.submitForm()
  }

  getFormElement() {
    // Find the form by ID or use the controller's element
    return this.element.closest('form') || document.getElementById(this.element.dataset.formId)
  }

  submitForm() {
    const form = this.getFormElement()
    if (!form) return
    
    // Use Turbo to submit the form without page redirection
    const formData = new FormData(form)
    const url = new URL(form.action, window.location.origin)
    
    // Add form data to URL for GET request
    for (const [key, value] of formData.entries()) {
      url.searchParams.set(key, value)
    }
    
    // Use Turbo.visit to navigate without full page reload
    if (typeof Turbo !== 'undefined') {
      Turbo.visit(url.toString(), {
        frame: this.element.dataset.frame || "bidscrm"
      })
    } else {
      // Fallback for non-Turbo environments
      window.location.href = url.toString()
    }
  }
}
